import requests from "./httpService";

const UserServices = { 
  getAllUsers: async () => {
    return requests.get("/user/all");
  }, 

  getUsersById: async (id) => {
    return requests.get(`/user/${id}`); 
  },

  addUsers: async (body) => {
    return requests.post("/user/add", body);
  },

  updateUsers: async (id, body) => {
    return requests.put(`/user/${id}`, body);
  },

  deleteUsers: async (id, body) => {
    return requests.delete(`/user/${id}`, body);
  },  

  getAllModules: async (body) => {
    return requests.post("/module/all", body);
  },   

  updateModulePermission: async (body) => {
    return requests.post("/module/employeePerm", body);
  }, 

  getUserModulesById: async (id) => {
    return requests.get(`/module/${id}`); 
  },

  getAllUserModules: async () => {
      return requests.get("/module");
  }, 

};

export default UserServices; 
